<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1 style="padding-top:150px;">Dedication</h1>
<p style="text-align: center;">To my brother, Bhudeb Sen.</p>
<p style="text-align: center;">Death took you away but you will be with me, forever.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?719c01a0